import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useStore } from '../../app/stores/store';
import {
  Dropdown,
  Form,
  Header,
  Icon,
  // Pagination,
  Segment,
  Table,
} from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import { manDaysType } from '../../app/models/Restoration';
import moment from 'moment';
import LoadingComponent from '../../app/layout/LoadingComponent';
import UnauthorizedMessage from '../UnauthorizedMessage';
import DynamicTableCSVReport from '../DynamicTable/DynamicTableCSVReport';

//Options
const titleAndDateData = [
  {
    key: 'Title',
    text: 'Title',
    value: 'Title',
  },
  {
    key: 'Date',
    text: 'Date',
    value: 'Date',
  },
];

const ManDaysReport = () => {
  // states
  const {
    RestorationStore,
    PivotStore,
    commonStore,
    RolesAndPermissionsIDStore,
  } = useStore();
  const { manDaysReportTitleInfo } = RestorationStore;
  const [titleAndDateInfo, setTitleAndDateInfo] = useState('');
  const [expandedRow, setExpandedRow] = useState(null);
  const [groupedData, setGroupedData] = useState<manDaysType[]>([]);
  const [activePage, setactivePage] = useState<any>(1);
  const [selectedTitle, setSelectedTitle] = useState<string[]>([]);
  const [reportData, setReportData] = useState<manDaysType[]>([]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setendDate] = useState('');

  // ========= static state
  const totalItems = 5;
  const startPage = (activePage - 1) * totalItems;
  const endPage = startPage + totalItems;

  // ========  UseEffects
  useEffect(() => {
    RestorationStore.hoursCalculateReport();
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, [RestorationStore.manDaysData, titleAndDateInfo]);

  useEffect(() => {
    const groupedData = {} as any;
    reportData?.forEach((item: any) => {
      if (!groupedData[item.title]) {
        groupedData[item.title] = [];
      }
      groupedData[item.title].push(item);
    });
    setGroupedData(Object.values(groupedData));
    // eslint-disable-next-line
  }, [reportData, RestorationStore.manDaysData, titleAndDateInfo]);

  useEffect(() => {
    const tempData = RestorationStore.manDaysData?.filter(
      (item: { title: any }) => {
        const TitleCode = item?.title;
        return selectedTitle.length === 0 || selectedTitle.includes(TitleCode);
      },
    );
    setReportData(tempData);
    // eslint-disable-next-line
  }, [selectedTitle]);
  useEffect(() => {
    if (startDate !== '' && endDate !== '') {
      toggleExpandRow(null);
      const dates = getDates(startDate, endDate);
      dates.forEach(function (date) {
        RestorationStore.DateFormatInfo.push(formatDate(date));
      });
      const tempData = RestorationStore.manDaysData?.filter(
        (item: { start_Date: any; end_Date: any }) => {
          const stateDate = item?.start_Date;
          const enddate = item?.end_Date;
          return (
            RestorationStore.DateFormatInfo?.includes(stateDate) &&
            RestorationStore.DateFormatInfo?.includes(enddate)
          );
        },
      );
      RestorationStore.DateFormatInfo.length = 0;
      setReportData(tempData);
    }
    // eslint-disable-next-line
  }, [startDate, endDate]);

  // =========== Functions

  const TitleAndDateFunc = (e: any, data: any) => {
    setTitleAndDateInfo(data.value);
    setStartDate('');
    setendDate('');
    setSelectedTitle([]);
    toggleExpandRow(null);
  };
  const toggleExpandRow = (titleCode: any) => {
    setactivePage(1);
    setExpandedRow(expandedRow === titleCode ? null : titleCode);
  };

  const selectiveMultipleValue = (e: any, data: any) => {
    setExpandedRow(null);
    if (data.value?.length > 0) {
      setSelectedTitle(data.value);
    } else {
      setSelectedTitle([]);
    }
  };
  const getData = async () => {
    setReportData(RestorationStore.manDaysData || []);
  };

  const setDate = (data: any, type: string) => {
    try {
      if (type === 'start') {
        setStartDate(data);
      } else {
        setendDate(data);
        setTimeout(() => {
          RestorationStore.DateFormatInfo.length = 0;
        }, 1000);
      }
    } catch (error) {
      console.error('Error', error);
    }
  };
  const formatDate = (dateString: any) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.getMonth() + 1; // Months are zero-based
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };

  function getDates(startDate: any, endDate: any) {
    const dates = [];
    let currentDate = startDate;
    const addDays = function (days: any) {
      const date = new Date(currentDate.valueOf());
      date.setDate(date.getDate() + days);
      return date;
    };
    while (currentDate <= endDate) {
      dates.push(currentDate);
      currentDate = addDays.call(currentDate, 1);
    }
    return dates;
  }

  return (
    <>
      {RestorationStore.restorationReportLoader === true && (
        <div style={{ marginTop: '30px' }}>
          <LoadingComponent />
        </div>
      )}
      {RestorationStore.restorationReportLoader !== true &&
        !RolesAndPermissionsIDStore.loadingInitial &&
        !commonStore.filterModeOne?.includes('RSMAHCR') && (
          <UnauthorizedMessage />
        )}
      {commonStore.filterModeOne?.includes('RSMAHCR') && (
        <div>
          <Segment clearing responsive={true}>
            <Header
              icon="user"
              size="huge"
              dividing
              as="h1"
              content={'Man Days Report'}
              sub
              color="grey"
            />
            <br />
            <div
              style={
                titleAndDateInfo !== ''
                  ? { display: 'flex', columnGap: '5%' }
                  : { display: 'flex', columnGap: '5%' }
              }
            >
              <h4 style={{ marginTop: '0.3%', marginRight: '-4%' }}>
                Report Type
              </h4>
              <Dropdown
                placeholder="Title Type"
                fluid
                selection
                options={titleAndDateData}
                style={{ width: '10%', height: '10%' }}
                value={titleAndDateInfo}
                onChange={(e: any, data: any) => TitleAndDateFunc(e, data)}
              />

              {titleAndDateInfo === 'Title' ? (
                <Dropdown
                  placeholder="Title"
                  fluid
                  selection
                  search
                  multiple
                  options={manDaysReportTitleInfo}
                  onChange={(e, data) => selectiveMultipleValue(e, data)}
                  style={{ width: '20%' }}
                />
              ) : titleAndDateInfo === 'Date' ? (
                <>
                  <Form.Field required={true}>
                    <div style={{ position: 'relative' }}>
                      <DatePicker
                        placeholderText="From Date"
                        value={
                          startDate ? PivotStore.dateFormat(startDate) : ''
                        }
                        className="date-picker-style"
                        showYearDropdown
                        locale={'en'}
                        dateFormatCalendar="MMMM"
                        yearDropdownItemNumber={15}
                        maxDate={moment().toDate()}
                        scrollableYearDropdown
                        onChange={(date: any) => setDate(date, 'start')}
                        popperProps={{ strategy: 'fixed' }}
                        showMonthDropdown
                      />
                    </div>
                  </Form.Field>
                  <Form.Field required={true}>
                    <div style={{ position: 'relative' }}>
                      <DatePicker
                        placeholderText="To Date"
                        value={endDate ? PivotStore.dateFormat(endDate) : ''}
                        showMonthDropdown
                        showYearDropdown
                        dateFormatCalendar="MMMM"
                        locale={'en'}
                        className="date-picker-style"
                        yearDropdownItemNumber={15}
                        maxDate={moment().toDate()}
                        scrollableYearDropdown
                        onChange={(date: any) => setDate(date, 'end')}
                        popperProps={{ strategy: 'fixed' }}
                      />
                    </div>
                  </Form.Field>
                </>
              ) : null}
            </div>
          </Segment>

          <Segment style={{ width: '100%', overflow: 'auto' }}>
            <Table style={{ width: '100%' }}>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell textAlign="left">Title</Table.HeaderCell>
                  <Table.HeaderCell textAlign="left" colSpan="3">
                    Title Details
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {groupedData.map((group: any, index: number) => (
                  <React.Fragment key={index}>
                    <Table.Row
                      // onClick={() => toggleExpandRow(group[0]?.title)}
                      textAlign="left"
                    >
                      <Table.Cell>
                        <div>{group[0]?.title}</div>
                      </Table.Cell>
                      <Table.Cell>
                        <span onClick={() => toggleExpandRow(group[0]?.title)}>
                          {expandedRow === group[0]?.title ? (
                            <Icon name="minus" color="grey" />
                          ) : (
                            <Icon name="plus" color="grey" />
                          )}
                        </span>
                      </Table.Cell>
                      {expandedRow === group[0]?.title && (
                        <Table.Row textAlign="right">
                          <Table>
                            <Table.Header>
                              <Table.Row>
                                <Table.HeaderCell>Shot No</Table.HeaderCell>
                                <Table.HeaderCell>Employee</Table.HeaderCell>
                                <Table.HeaderCell>Description</Table.HeaderCell>
                                <Table.HeaderCell>Total Frame</Table.HeaderCell>
                                <Table.HeaderCell>
                                  Estimate Matte Paint Mandays
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                  Actual Matte Paint Mandays
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                  estimate Paint Mandays
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                  actual Paint Mandays
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                  Estimate Comp Mandays
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                  Actual Comp Mandays
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                  Estimate Roto Mandays
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                  Actual Roto Mandays
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                  Estimate 3D Mandays
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                  Actual 3D Mandays
                                </Table.HeaderCell>
                                <Table.HeaderCell>Start Date</Table.HeaderCell>
                                <Table.HeaderCell>End Date</Table.HeaderCell>
                                <Table.HeaderCell>
                                  Status Check
                                </Table.HeaderCell>
                                <Table.HeaderCell>Metadata</Table.HeaderCell>
                              </Table.Row>
                            </Table.Header>
                            <Table.Body>
                              {group
                                ?.slice(startPage, endPage)
                                ?.map((item: any, index: number) => (
                                  <Table.Row key={index}>
                                    <Table.Cell>{item.shot_No}</Table.Cell>
                                    <Table.Cell>{item.employee}</Table.Cell>
                                    <Table.Cell>{item.description}</Table.Cell>
                                    <Table.Cell>{item.total_Frame}</Table.Cell>
                                    <Table.Cell>
                                      {item.estimate_Matte_Paint_Mandays}
                                    </Table.Cell>
                                    <Table.Cell>
                                      {item.actual_Matte_Paint_Mandays}
                                    </Table.Cell>
                                    <Table.Cell>
                                      {item.estimate_Paint_Mandays}
                                    </Table.Cell>
                                    <Table.Cell>
                                      {item.actual_Paint_Mandays}
                                    </Table.Cell>
                                    <Table.Cell>
                                      {item.estimate_Comp_Mandays}
                                    </Table.Cell>
                                    <Table.Cell>
                                      {item.actual_Comp_Mandays}
                                    </Table.Cell>
                                    <Table.Cell>
                                      {item.estimate_Roto_Mandays}
                                    </Table.Cell>
                                    <Table.Cell>
                                      {item.actual_Roto_Mandays}
                                    </Table.Cell>
                                    <Table.Cell>
                                      {item.estimate_3D_Mandays}
                                    </Table.Cell>
                                    <Table.Cell>
                                      {item.actual_3D_Mandays}
                                    </Table.Cell>
                                    <Table.Cell>{item.start_Date}</Table.Cell>
                                    <Table.Cell>{item.end_Date}</Table.Cell>
                                    <Table.Cell>{item.statuscheck}</Table.Cell>
                                    <Table.Cell>{item.metadata}</Table.Cell>
                                  </Table.Row>
                                ))}
                            </Table.Body>
                            <Table.Row>
                              <Table.Cell
                                colSpan={6}
                                textAlign="left"
                              ></Table.Cell>
                            </Table.Row>
                          </Table>
                        </Table.Row>
                      )}
                    </Table.Row>
                  </React.Fragment>
                ))}
              </Table.Body>
            </Table>
            <br />
            <div className="dynamicTableFooter">
              <div></div>
              <div>
                <DynamicTableCSVReport
                  tableData={groupedData}
                  tableName={'ReportsTable'}
                  // I need reportsTable title data so i use this
                  name={'OpratorPerformance'}
                />
              </div>
            </div>
          </Segment>
        </div>
      )}
    </>
  );
};
export default observer(ManDaysReport);
